import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommPocketIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M5.69628 1.75C4.07611 1.75 2.80706 3.14359 2.95829 4.75669L4.14234 17.3866C4.23637 18.3895 4.8712 19.2608 5.79706 19.6576L10.9167 21.8517C11.6085 22.1482 12.3915 22.1482 13.0833 21.8517L18.203 19.6576C19.1288 19.2608 19.7637 18.3895 19.8577 17.3866L21.0417 4.75669C21.193 3.14359 19.9239 1.75 18.3037 1.75H5.69628ZM4.45174 4.61668C4.383 3.88345 4.95984 3.25 5.69628 3.25H18.3037C19.0402 3.25 19.617 3.88345 19.5483 4.61668L19.4655 5.5H4.53455L4.45174 4.61668ZM4.67518 7L5.63579 17.2466C5.67853 17.7025 5.96709 18.0985 6.38794 18.2789L11.5076 20.473C11.822 20.6078 12.178 20.6078 12.4924 20.473L17.6121 18.2789C18.0329 18.0985 18.3215 17.7025 18.3642 17.2466L19.3248 7H4.67518Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
